// extracted by mini-css-extract-plugin
module.exports =  {"section":"_33974c2b58--section--MFdin","header":"_33974c2b58--header--qyfQr","recommendations":"_33974c2b58--recommendations--jPIMV"};